module.exports = __webpack_public_path__ + "static/media/downloadIcon.254dd29c.svg";